<template>
    <div class="card-carousel__section-title">{{ title }}</div>
    <div class="card-carousel card-carousel--multirow">
            <div 
                class="card-carousel__wrapper card-carousel__wrapper--multi"
                ref="wrapper" 
            >
                <div class="card-carousel__row" v-for="(row, rowIndex) in rows" :key="rowIndex + uuid">
                <swiper
                    :id="rowIndex + '-swiper' + uuid"
                    :modules="modules"
                    :space-between="gutter"
                    :navigation="{
                        nextEl: '#swiper-' + rowIndex + '-next' + uuid,
                        prevEl: '#swiper-' + rowIndex + '-prev' + uuid,
                    }"
                    :loop="false"
                    @swiper="onSwiper"
                    @slideChange="onSlideChange"
                    :slidesOffsetAfter="paddingRight"
                    :slidesOffsetBefore="paddingLeft" 
                    :scrollbar="scrollbar"
                    :allowTouchMove="row.slides.length > 1 ? true : false"
                    :draggable="row.slides.length > 1 ? true : false"
                    :mousewheel="row.slides.length > 1 ? mousewheel : false"
                    :resizeObserver="true"
                    :updateOnWindowResize="true"
                    :zoom="false"
                    :snapIndex="1"
                    :snapOnRelease="false"
                    :breakpoints="{
                        320: {
                            slidesPerView: 1,
                            centeredSlides: true,
                        },
                        768: {
                            slidesPerView: 2,
                            centeredSlides: false,
                        },
                        960: {
                            slidesPerView: 3,
                             centeredSlides: false,
                        },
                    }"
                >
                    <swiper-slide 
                        class="card-carousel__slide"
                        v-for="(slide, slideIndex) in row.slides" 
                        :key="slideIndex + uuid"
                    >
                        <div class="card-carousel__image" :style="`background-image:url(${slide.backgroundImage})`"></div>
                        <div class="card-carousel__container">
                            <div class="card-carousel__title">{{ slide.title }}</div>
                            <p class="card-carousel__content">{{slide.richTextContent}}</p>
                            <a v-if="slide.link != null" class="card-carousel__link" :href="slide.link.Url" :target="slide.link.Target"
                                    :title="slide.link.Name">{{slide.link.Name}}</a>
                        </div>
                    </swiper-slide>
                </swiper>
                <button :id="'swiper-' + rowIndex + '-prev' + uuid" class="card-carousel__swiper-prev swiper__button swiper__button--prev" type="button"><span>Prev</span></button>
                <button :id="'swiper-' + rowIndex + '-next' + uuid" class="card-carousel__swiper-next swiper__button swiper__button--next" type="button"><span>Next</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import { Mousewheel, Navigation, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/bundle";

export default {
    props: ["rows", "title", "showLegend", "uuid"],
    components: {
        Swiper,
        SwiperSlide,
    },
   
    data() {
        return {
            paddingRight: 16,
            paddingLeft: 16,
            gutter: 16,
        }
    },
     mounted() {
        let self = this;
        self.setSidePadding();
        window.addEventListener("resize", function () {
            self.setSidePadding();
        });
    },
    computed: {
        longestRow: function () {
            if (this.rows.length > 0) {
                let sorted = this.rows.sort((a, b) => b.slides.length - a.slides.length);
                return sorted[0].slides.length;
            }

            return 0;
        }
    },
    methods: {
       setSidePadding: function () {
            // spacing
            if (window.innerWidth >= 960) {
                this.paddingLeft = 0;
                this.paddingRight = 0;
            } else {
                this.paddingLeft = 16;
                this.paddingRight = 16;
            }
        },
    },
    setup() {
        const onSwiper = (swiper) => { };
        const onSlideChange = (swiper) => { };
        return {
            onSwiper,
            onSlideChange,
            scrollbar: {
                el: ".card-carousel__legend",
                draggable: true,
                dragClass: "card-carousel__legend-bar",
            },
            mousewheel: {
                forceToAxis: true,
            },
            modules: [Navigation, Scrollbar, Mousewheel],
        };
    },
}
</script>
